const Features = () => {
  const features = [
    "Technical analysis for NIFTY, BANKNIFTY, FINNIFTY & SENSEX",
    "Clear and precise trading levels",
    "Global markets and News",
    "FII & DII insights",
  ];

  return (
    <div className="flex flex-col space-y-4">
      <h3 className="text-lg font-semibold text-p300">What's in the report?</h3>
      <div className="flex flex-col space-y-3">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start">
            <svg
              className="h-5 w-5 text-p150 mr-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-sm font-normal text-p300">{feature}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
